const SERVICE_NAME = 'agent-dashboard';
const TELEMETRY_ENDPOINT = '/api/v1/telemetry/errors';

interface ErrorReport {
  level: string;
  message: string;
  stack_trace?: string;
  request_path?: string;
  status_code?: number;
  user_id?: string;
  timestamp: string;
  metadata: Record<string, any>;
}

let buffer: ErrorReport[] = [];
let timer: ReturnType<typeof setTimeout> | null = null;

function flush() {
  if (timer) { clearTimeout(timer); timer = null; }
  if (!buffer.length) return;
  const batch = buffer.splice(0);
  const body = JSON.stringify({ logs: batch });
  if (navigator.sendBeacon) {
    const blob = new Blob([body], { type: 'application/json' });
    navigator.sendBeacon(TELEMETRY_ENDPOINT, blob);
  } else {
    fetch(TELEMETRY_ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true }).catch(() => {});
  }
}

export function reportError(error: Error | string, metadata: Record<string, any> = {}) {
  const err = typeof error === 'string' ? new Error(error) : error;
  buffer.push({
    level: 'error',
    message: err.message,
    stack_trace: err.stack,
    request_path: window.location.pathname,
    user_id: localStorage.getItem('access_token') ? 'authenticated' : undefined,
    timestamp: new Date().toISOString(),
    metadata: { userAgent: navigator.userAgent, url: window.location.href, service: SERVICE_NAME, ...metadata },
  });
  if (!timer) timer = setTimeout(flush, 5000);
  if (buffer.length >= 5) flush();
}

export function reportApiError(path: string, status: number, message: string) {
  reportError(message, { request_path: path, status_code: status, type: 'api_error' });
}

export function initGlobalErrorHandlers() {
  window.addEventListener('error', (e) => {
    reportError(e.error || e.message, { type: 'uncaught_error', filename: e.filename, lineno: e.lineno });
  });
  window.addEventListener('unhandledrejection', (e) => {
    reportError(e.reason instanceof Error ? e.reason : new Error(String(e.reason)), { type: 'unhandled_rejection' });
  });
  window.addEventListener('beforeunload', flush);
}
